var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryIcon = function SvgHistoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M20.978 7.625a9.93 9.93 0 0 0-5.72-5.07A9.99 9.99 0 0 0 4.915 4.936V4.27a1 1 0 0 0-2 0v3.3a1 1 0 0 0 1 1h3.28a1 1 0 1 0 0-2H6.129a8 8 0 0 1 8.476-2.125A7.94 7.94 0 0 1 19.18 8.5a7.93 7.93 0 0 1 .367 6.104 7.93 7.93 0 0 1-4.056 4.586 7.92 7.92 0 0 1-6.108.363 7.97 7.97 0 0 1-5.094-5.41 1 1 0 1 0-1.928.532 9.96 9.96 0 0 0 6.369 6.77c1.072.37 2.176.555 3.278.555a9.9 9.9 0 0 0 4.358-1.012 9.91 9.91 0 0 0 5.07-5.732c.874-2.52.71-5.23-.459-7.63",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M8.986 15.568a1 1 0 0 0 .513-.142l3.174-1.9c.3-.18.486-.507.486-.858v-4.1a1 1 0 0 0-2 0v3.533l-2.688 1.61a1 1 0 0 0 .515 1.857",
    clipRule: "evenodd"
  })));
};
export default SvgHistoryIcon;